import { render, staticRenderFns } from "./ErrorText.vue?vue&type=template&id=4bd3597e&scoped=true&"
import script from "./ErrorText.vue?vue&type=script&lang=js&"
export * from "./ErrorText.vue?vue&type=script&lang=js&"
import style0 from "./ErrorText.vue?vue&type=style&index=0&id=4bd3597e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3597e",
  null
  
)

export default component.exports